import Api from '../Api';

import { url } from './config';
import { PriceLevel } from './types';

const api = new Api<PriceLevel>(url);

export default api;
